module.exports = __webpack_public_path__ + "img/svip.297b9347.png";